import React, { useState, useEffect } from "react";
import fetchData from "../../services/requester-website";
import { imagePath } from "../../helpers/global";
import { defaultSettings } from "../../helpers/default-settings";

const HomeWhyus = (props) => {
  const [data, setData] = useState([]);

  const getData = () => {
    let reqURL = "whyus";
    let reqOBJ = "";
    fetchData(
      reqURL,
      reqOBJ,
      (data) => {
        data && setData(data?.filter((x) => x?.showOnHome) || []);
      },
      "GET"
    );
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    data &&
    data.length > 0 && (
      <div className="home-whyus">
        <h2 className="home-title">
          {props?.whyusTitle || defaultSettings?.whyusTitle}
        </h2>
        <p className="home-sub-title">
          {props?.whyusSubTitle || defaultSettings?.whyusSubTitle}
        </p>
        <div className="row">
          {data?.map(
            (x, key) =>
              key < 4 && (
                <div key={key} className="col-lg-3">
                  <div className="home-whyus-wrap">
                    <img src={imagePath() + x?.imageURL} alt={x?.title} />
                    <h3>{x?.title}</h3>
                    <p>{x?.subTitle}</p>
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    )
  );
};

export default HomeWhyus;
